<dx-box width="100%" height="100%" direction="col">
    <dxi-item baseSize="auto" [visible]="!customerId">
        <div *dxTemplate>
            <div class="row-container">
                Closed Work Orders In Past
                <div class="add-padding">
                    <dx-number-box
                        format="#"
                        [min]="1"
                        [max]="3650"
                        [width]="90"
                        [(value)]="numberOfDays"
                        (onInput)="onNoOfDaysChange($event)"
                    ></dx-number-box>
                </div>
                Days
                <div class="add-padding">
                    <dx-button
                        type="default"
                        text="Refresh"
                        hint="Refresh"
                        [icon]="iconRefresh"
                        (onClick)="forceRefresh()"
                    ></dx-button>
                </div>
            </div>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <app-work-order-grid
                workOrderStatus="closed"
                [isPopup]="isPopup"
                [workOrdersGridSource]="closedWorkOrders"
                [workOrderIds]="workOrderIds"
                (onForceReload)="forceRefresh()"
                (onWorkOrderSelection)="onWorkOrderRecordsSelection($event)"
                (onWorkOrderDeselection)="onWorkOrderRecordsDeselection($event)"
            ></app-work-order-grid>
        </div>
    </dxi-item>
</dx-box>
